import { t } from "i18next";

export const getAccountTypeTranslation = (accountType) => {
  return {
    TRANSACTIONAL: t("delivery.accounts.show.detailInfo.type.transactional"),
    NEWSLETTER: t("delivery.accounts.show.detailInfo.type.promotional"),
  }[accountType.toUpperCase()];
};
